module.exports = __webpack_public_path__ + "static/media/red_doc_header@2x.75144bfa.png";